import { createRouter, createWebHistory} from 'vue-router'

import EfirmaHome from "@/components/EfirmaHome.vue";
import Login from "@/components/LoginComponent.vue";
import OrderList from "@/components/OrderList.vue";
import UserList from "@/components/UserList.vue";
import UserEdit from "@/components/UserEdit.vue";
import OrderEdit from "@/components/OrderEdit.vue";
import MessageList from "@/components/MessageList.vue";
import IgnoredEmailList from "@/components/IgnoredEmailList.vue";
import OrdersHome from "@/components/OrdersHome.vue";
import StockHome from "@/components/StockHome.vue";
import CategoryList from "@/components/CategoryList.vue";
import CategoryEdit from "@/components/CategoryEdit.vue";
import ColorList from "@/components/ColorList.vue";
import ColorEdit from "@/components/ColorEdit.vue";
import ProductList from "@/components/ProductList.vue";
import ProductEdit from "@/components/ProductEdit.vue";
import BoxList from "@/components/BoxList.vue";
import BoxEdit from "@/components/BoxEdit.vue";
import StockItemList from "@/components/StockItemList.vue";
import StockItemEdit from "@/components/StockItemEdit.vue";
import PackageList from "@/components/PackageList.vue";
import PackageEdit from "@/components/PackageEdit.vue";
import ScanItem from "@/components/ScanItem.vue";
import StockItemBulkAddition from "@/components/StockItemBulkAddition.vue";
import SearchStockItems from "@/components/SearchStockItems.vue";
import ReservationRequestList from "@/components/ReservationRequestList.vue";
import ReservationRequestEdit from "@/components/ReservationRequestEdit.vue";

const routes = [
  {
      path : '/',
      name: 'EfirmaHome',
      component: EfirmaHome
  },
  {
      path : '/login',
      name: 'Login',
      component: Login
  },

  {
      path: '/mod-orders/orders',
      name: 'OrderList',
      component: OrderList
  },
  
  {
      path: '/mod-orders/order/:orderId',
      name: 'OrderEdit',
      component: OrderEdit
  }, 

 
  {
    path: '/mod-orders/ignored_emails',
    name: 'IgnoredEmailList',
    component:IgnoredEmailList
  },

  {
    path: '/mod-orders/messages/:typ/:id',
    name: 'MessageList',
    component: MessageList
  },

  {
      path: '/admin/users',
      name: 'UserList',
      component: UserList,
  },

  {
      path: '/admin/users/:userId',
      name: 'UserEdit',
      component: UserEdit,
  },

  {
    path : '/mod-orders',
    name: 'OrdersHome',
    component: OrdersHome,
  },
  
  {
    path : '/mod-stock',
    name: 'StockHome',
    component: StockHome,
  },

  {
    path : '/mod-stock/categories',
    name: 'CategoryList',
    component: CategoryList,
  },

  {
    path : '/mod-stock/categories/:categoryId',
    name: 'CategoryEdit',
    component: CategoryEdit,
  },

  {
    path : '/mod-stock/colors',
    name: 'ColorList',
    component: ColorList,
  },

  {
    path : '/mod-stock/colors/:colorId',
    name: 'ColorEdit',
    component: ColorEdit,
  },
  
  {
    path : '/mod-stock/products',
    name: 'ProductList',
    component: ProductList,
  },

  {
    path : '/mod-stock/products/:productId',
    name: 'ProductEdit',
    component: ProductEdit,
  },

  {
    path : '/mod-stock/boxies',
    name: 'BoxList',
    component: BoxList,
  },

  {
    path : '/mod-stock/boxies/:boxId',
    name: 'BoxEdit',
    component: BoxEdit,
  },

  {
    path : '/mod-stock/stock-items',
    name: 'StockItemList',
    component: StockItemList,
  },

  {
    path : '/mod-stock/stock-items/:stockItemId',
    name: 'StockItemEdit',
    component: StockItemEdit,
  },

  {
    path : '/mod-stock/packages',
    name: 'PackageList',
    component: PackageList,
  },

  {
    path : '/mod-stock/packages/:packageId',
    name: 'PackageEdit',
    component: PackageEdit,
  },

  {
    path : '/mod-stock/scan-item',
    name: 'ScanItem',
    component: ScanItem,
  },

  {
    path : '/mod-stock/bulk-add-items',
    name: 'StockItemBulkAddition',
    component: StockItemBulkAddition,
  },

  {
    path : '/mod-stock/search-items',
    name: 'SearchStockItems',
    component: SearchStockItems,
  },

  {
    path : '/mod-stock/reservation-requests/:typ',
    name: 'ReservationRequestList',
    component: ReservationRequestList,
  },

  {
    path : '/mod-stock/reservation-requests/:typ/:resReqId',
    name: 'ReservationRequestEdit',
    component: ReservationRequestEdit,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
